import { LockIcon } from "@phosphor-icons/react/dist/csr/Lock";
import { Stack } from "@volca/ui/components/ui/stack";
import { ChatPanelHeader } from "./chat-panel-header";

interface AccessDeniedStateProps {
  onClose: () => void;
}

export const AccessDeniedState = ({ onClose }: AccessDeniedStateProps) => (
  <Stack align="stretch" className="h-full min-h-0 w-full" gap={0}>
    <ChatPanelHeader title="Payroll chat" onClose={onClose} />
    <Stack
      align="center"
      justify="center"
      gap={2}
      className="flex-1 px-8 text-center"
    >
      <span className="flex size-9 items-center justify-center rounded-xl bg-neutral text-subtle">
        <LockIcon aria-hidden className="size-4" />
      </span>
      <h3 className="text-base font-medium text-ink">
        Payroll chat isn't available
      </h3>
      <p className="text-sm text-subtle">
        You don't have access to this pay period's workbook. Ask an admin to
        grant you access if you think this is a mistake.
      </p>
    </Stack>
  </Stack>
);
